module.exports = __webpack_public_path__ + "static/media/k1.292bd3a0.jpg";